export default "__VITE_PUBLIC_ASSET__690126a7__"